// billing.schema.ts
// @ts-nocheck
import * as Yup from 'yup';

export const billingAddressFormSchema = Yup.object({
    firstName: Yup.string()
        .required('First name is a required field')
        .matches(/^[a-zA-Z\s\-]+$/, 'Only alphabets are allowed for this field')
        .max(30, 'Max 30 characters'),
    lastName: Yup.string()
        .required('Last name is a required field')
        .matches(/^[a-zA-Z\s\-]+$/, 'Only alphabets are allowed for this field')
        .max(30, 'Max 30 characters'),
    company: Yup.string().optional().max(30, 'Max 30 characters'),
    streetAddress: Yup.string()
        .required('Street address is a required field')
        .max(60, 'Max 60 characters'), // no P.O. Box restriction
    apartment: Yup.string().optional().max(60, 'Max 60 characters'),
    city: Yup.string().required('City is a required field').max(30, 'Max 30 characters'),
    state: Yup.string()
        .required('State is a required field')
        .matches(/^[A-Z]{2}$/, 'Must have exactly two characters in this field')
        .max(60, 'Max 30 characters'),
    zipCode: Yup.string()
        .required('Zip Code is a required field')
        .matches(/^(?:\d{5}(?:[-\s]\d{4})?|\d{9})$/, 'Invalid zip code')
        .min(5, 'Invalid zip code')
        .max(10, 'Invalid zip code'),
});
